'use client';

import { useMountEffect } from '@flipster/react/misc/lifecycle/mount';
import segment, { SegmentDataType, SegmentTypes } from '@flipster/utils/segment';

interface Props<T extends SegmentTypes> {
  name: T;
  context?: SegmentDataType[T];
}

export const SegmentTrack = <T extends SegmentTypes>({ name, context }: Props<T>) => {
  useMountEffect(() => segment.track(name, context));
  return null;
};
